import React from 'react';
import PropTypes from 'prop-types';
import './research.css';
import Link from 'gatsby-link';

import placeholder from '../../images/placeholder.jpg';

class Research extends React.Component {

  static propTypes = {
    image: PropTypes.string,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    link: PropTypes.string.isRequired,
    first: PropTypes.bool
  }

  static defaultProps = {
    image: placeholder,
    title: "Hello World",
    subtitle: "",
    link: "",
    first: false
  }

  render() {

    let classNm = "";
    this.props.first ? classNm = "col-xs-6 col-sm-6 col-md-6 col-lg-offset-1 col-lg-3dot3 col-xl-3dot3" : classNm = "col-xs-6 col-sm-6 col-md-6 col-lg-3dot3 col-xl-3dot3";
    return (
      <div className={"research-container " + classNm} >
        <a href={this.props.link}>
        <div className={"research-blurb"} style={{ backgroundImage: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%), url(" + this.props.image+")"}}>
          <div className={"push-down"}></div>
          <h4>{this.props.title}</h4>
        </div>
        </a>
      </div>
    )
  }
}

export default Research;


// WEBPACK FOOTER //
// ./src/components/Research/research.js